var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-field-connector",style:({
      height: (_vm.connectorHeight + "px"),
      margin: ("-" + _vm.elementHalfHeight + "px 0")
    })})}
var staticRenderFns = []

export { render, staticRenderFns }